import { makeStyles } from "@material-ui/core/styles";
import bg from '../../assets/ultrasound.jpg';
export const useStyles = makeStyles((theme) => ({
  paper: {
    margin:  `0 auto`,
    paddingTop: '80px',
    paddingBottom: 120,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    "@media (max-width: 1000px)": {
      maxWidth: '50%',
      flexBasis: '50%'
    },
    "@media (max-width: 760px)": {
      maxWidth: '90%',
      flexBasis: '90%'
    }
  },
  loginWrapper: {
    backgroundImage: `url(${bg})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '100%',
    maxWidth: '100%',
  },
  header: {
      fontSize: '30pt',
      color: 'white',
      marginTop: 70,
      paddingBottom: 30
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
    backgroundColor: 'white',
    padding: '15px 25px 15px 25px',
    borderRadius: 15
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: '#E32B29',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    margiTop: '5px',
  },
  checkboxLabel: {
    fontSize: '9pt'
  },
  accountCreatedWrapper: {
    margin: '0 auto',
    maxWidth: '600px',
    paddingTop: 140,
    paddingBottom: 100
  },
  verificationMessage: {
    backgroundColor: 'white',
    padding: '70px 25px 70px 25px',
    borderRadius: 15
  },
  accountCreatedHeader: {
    textAlign: 'center',
    fontSize: '30pt',
    paddingBottom: 20
  },
  accountCreatedText: {
    textAlign: 'center',
    paddingTop: 15
  },
  card: {
    backgroundColor: '#0cc109'
  },
  cardContent: {
    paddingBottom: '15px!important'
  },
  cardText: {
    color: 'white'
  },
  paymentDescription: {
    padding: '15px 15px 0px 15px',
    textAlign: 'center'
  },
  paymentDisclaimer: {
    fontSize: '10px',
    textAlign: 'center',
    paddingTop: 50
  }
}));